import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.DefaultBankAccountResponse,
  (requestParams: vp.DefaultBankAccountRequest) => void,
  () => void,

  vp.Api['fetchDefaultBankAccount'],
];

function useFetchDefaultBankAccount({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [params, setParams] = useState<vp.DefaultBankAccountRequest>();

  const [response, setResponse] = useState<vp.DefaultBankAccountResponse>({
    ErrorMessage: '',
    Success: false,
    DefaultBillingBankAccount: [],
    DefaultOperationalBankAccount: [],
  });

  const [shouldSendRequest, setSendRequest] = useState(false);

  useEffect(() => {
    const sendRequest = async (requestParams: vp.DefaultBankAccountRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.fetchDefaultBankAccount(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.DefaultBankAccountRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setSendRequest(false);
      setParams(undefined);

      setResponse({
        ErrorMessage: '',
        Success: false,
        DefaultBillingBankAccount: [],
        DefaultOperationalBankAccount: [],
      });
    },
    (req: vp.DefaultBankAccountRequest) => api.fetchDefaultBankAccount(req, source),
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchDefaultBankAccount);
